export const primaryNavigations = [
    {
        name: "home",
        title: "Home",
        type: "link",
        path: "/"
    },
    {
        name: "experience",
        title: "Experience",
        type: "link",
        path: "/experience"
    },
    {
        name: "contact",
        title: "Contact",
        type: "link",
        path: "/contact"
    }
];